module.exports = __webpack_public_path__ + "media/img/corporate/bg-corp-61746aef5af0bf8493a1592d26df2abc.jpg";